var locale = {
  placeholder: 'நேரத்தைத் தேர்ந்தெடுக்கவும்'
};
export default locale;
//# sourceMappingURL=ta_IN.js.map
